<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap my-6 mx-6 mb-6">

          <div class="w-full md:w-1/2 px-3 mb-6">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Pick event color</label
            >
            <v-text-field v-model="color" class="ma-0 pa-0" hide-details solo>
              <template v-slot:append>
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    nudge-bottom="105"
                    nudge-left="16"
                    top
                >
                  <template v-slot:activator="{ on }">
                    <div :style="swatchStyle" v-on="on"/>
                  </template>
                  <v-card>
                    <v-card-text class="pa-0">
                      <v-color-picker v-model="color" flat/>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </template>
            </v-text-field>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Expected Outcome</label>
            <validation-provider v-slot="{ errors }">
              <textarea
                  v-model="formValues.expectedOutcome"
                  class="event-outcome-field shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="Enter Expected Outcome."
                  rows="1"
              ></textarea>
              <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Event Start Date(EC)</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-menu
                  ref="menu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formValues.start"
                      :clearable="true"
                      label="Pick start date"
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="formValues.start"
                    :max="formValues.end ? formValues.end : null"
                    :min="date"
                    no-title
                    scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Event End Date(EC)</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-menu
                  ref="menu"
                  v-model="endMenu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formValues.end"
                      :clearable="true"
                      :disabled="enableEndDate"
                      label="Pick end date"
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="formValues.end"
                    :min="formValues.start ? formValues.start : null"
                    no-title
                    scrollable
                    @input="endMenu = false"
                ></v-date-picker>
              </v-menu>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >CPD Activity</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.programId"
                  :elevation="1"
                  :items="PROGRAMS"
                  :loading="programLoading"
                  dense
                  item-text="category.name"
                  item-value="id"
                  solo
                  @change="cActivityOnChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>
          <div v-if="isCategory1 == true" class="w-full md:w-1/2 px-3 mb-6">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Courses</label
            >
            <div v-for="item in COURSES" :key="item.id">
              <v-checkbox
                  :label="item.course.courseName"
                  disabled
                  input-value="true"
              ></v-checkbox>
            </div>
            <br/>
          </div>
          <div
              v-else-if="isCategory1 == false"
              class="w-full md:w-1/2 px-3 mb-6"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Courses</label
            >
            <div v-for="item in COURSES" :key="item.courseName">
              <v-checkbox
                  :label="item.courseName"
                  disabled
                  input-value="true"
              ></v-checkbox>
            </div>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >CPD Provider</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.trainingCenterId"
                  :elevation="1"
                  :items="TRAINING_CENTERS"
                  :loading="tCenterLoading"
                  dense
                  disabled
                  item-text="trainingCenterName"
                  item-value="id"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Actual Outcome</label
            >
            <validation-provider v-slot="{ errors }">
              <textarea
                  v-model="formValues.actualOutcome"
                  :disabled="!showActualOutcome"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                "
                  placeholder="Enter Actual Outcome."
                  rows="3"
              ></textarea>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>

          <div v-if="false" class="w-full md:w-1/2 px-3 mb-6 mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Funded By:</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <select
                  v-model="formValues.fundedById"
                  class="
                  minimal
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                "
              >
                <option
                    v-for="item in FUNDED_BY"
                    :key="item.id"
                    :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>

            <br/>
          </div>
          <div class="w-full px-3 mb-6">
            <div class="flex items-center justify-between mb-3">
              <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold">Funders</label>
              <v-btn color="primary" outlined small type="button" @click="addFunder">
                <v-icon left small>mdi-plus</v-icon>Add Funder
              </v-btn>
            </div>
            <div v-if="!formValues.funders.length" class="text-gray-500 text-sm">No funders added.</div>
            <div
                v-for="(funder, index) in formValues.funders"
                :key="funder.id || `new-funder-${index}`"
                class="flex flex-wrap items-start funder-row"
            >
              <div class="w-full md:w-1/2 pr-3 required">
                <validation-provider v-slot="{ errors }" rules="required">
                  <v-autocomplete
                      v-model="funder.organizationId"
                      :items="availableFunders(index)"
                      item-text="name"
                      item-value="id"
                      label="Funder"
                      outlined
                      dense
                  />
                  <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="w-full md:w-1/3 px-3 required">
                <validation-provider v-slot="{ errors }" rules="required|min_value:0">
                  <v-text-field v-model="funder.fundAmount" label="Fund Amount" type="number" min="0" outlined dense />
                  <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="w-full md:w-1/6 pt-1 text-right">
                <v-btn icon color="red" type="button" @click="removeFunder(index)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Total Cost:
            </label>
            <validation-provider
                v-slot="{ errors }"
                rules="required|min_value:0"
            >
              <input
                  id="totalCost"
                  v-model="formValues.totalCost"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="Total cost"
                  type="number"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full">
            <button
                class="
                float-right
                shadow
                bg-teal-600
                hover:bg-teal-600
                focus:shadow-outline
                focus:outline-none
                text-white
                font-bold
                py-2
                px-4
                rounded
              "
                type="button"
                @click="submit()"
            >
              {{ formValues.editMode ? "Update Event" : "Add Event" }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {getTrainers, getTrainees, getFoundedBy} from "@/utils/helper";
import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import {required, min_value} from "vee-validate/dist/rules";
import {TrainingCenterService} from "../TrainingCenter/training_center.service";
import {ProgramService} from "../Programs/programs.service";
import ethiopic from "ethiopic-calendar";
import {LookupService} from "@/common/api.service";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("min_value", {
  ...min_value,
  message: "Invalid Value",
});
export default {
  props: {
    programEvent: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        start: "",
        end: "",
        programId: "",
        trainingCenterId: "",
        color: "",
        expectedOutcome: "",
        actualOutcome: "",
        totalCost: null,
        fundedById: null,
        funders: [],
        editMode: false,
      },
      color: "#1976D2FF",
      mask: "!#XXXXXXXX",
      menu: false,
      showProgress: false,
      PROGRAMS: [],
      TRAINING_CENTERS: [],
      TRAINEES: [],
      TRAINERS: [],
      date: new Date().toISOString().substr(0, 10),
      startMenu: false,
      endMenu: false,
      modal: false,
      showActualOutcome: false,
      FUNDED_BY: [],
      ORGANIZATIONS: [],
      enableEndDate: true,
      selectedStartDate: null,
      selectedEndDate: null,
      programLoading: false,
      tCenterLoading: false,
      COURSES: [],
      isCategory1: null,
      editChangeCount: 0,
      selectedEventCType: null,
      etDate: null
    };
  },
  async beforeMount() {
    // this.PROGRAMS = await getPrograms();
    const res = await TrainingCenterService.getAllTrainingCenters();
    this.TRAINING_CENTERS = res.data ? res.data : null;
    this.TRAINERS = await getTrainers();
    this.TRAINEES = await getTrainees();
    this.FUNDED_BY = await getFoundedBy();
    const organizationResponse = await LookupService.getOrganizations("Donor");
    this.ORGANIZATIONS = organizationResponse?.data?.rows || [];
  },
  computed: {
    swatchStyle() {
      const {color, menu} = this;
      return {
        backgroundColor: color,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
  },
  created() {
    this.etDate = this.convertGE(this.date);
    if (this.programEvent != null) {
      const eventCopy = JSON.parse(JSON.stringify(this.programEvent));
      this.formValues = {
        ...this.formValues,
        ...eventCopy,
        editMode: true,
      };
      this.color = eventCopy.color || this.color;
      this.formValues.trainingCenterId = this.formValues.trainingCenterId || eventCopy.trainingCenter?.id || "";
      this.formValues.programId = this.formValues.programId || eventCopy.program?.id || "";
      this.formValues.start = this.convertGE(eventCopy.start);
      this.formValues.end = this.convertGE(eventCopy.end);
      this.selectedEventCType = this.formValues.program
          ? this.formValues.program.category
              ? this.formValues.program.category.categoryType
              : null
          : null;
      this.cActivityOnChange(
          this.formValues.programId,
          this.selectedEventCType
      );

      const currentDate = new Date().toISOString().substr(0, 10);
      eventCopy.end <= currentDate
          ? (this.showActualOutcome = true)
          : (this.showActualOutcome = false);
    }
  },
  methods: {
    addFunder() {
      this.formValues.funders.push({organizationId: null, fundAmount: null});
    },
    removeFunder(index) {
      this.formValues.funders.splice(index, 1);
    },
    availableFunders(currentIndex) {
      const selected = new Set(
          this.formValues.funders
              .filter((_, index) => index !== currentIndex)
              .map((funder) => Number(funder.organizationId))
              .filter(Boolean)
      );
      return this.ORGANIZATIONS.filter((organization) => !selected.has(Number(organization.id)));
    },
    convertGE(val) {
      if (!val) return val;
      const [year, month, day] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
        return etDate.year.toString().padStart(4, "0");
      } else {
        let etDate = ethiopic.ge(year, month || 1, day || 1);
        return (
            etDate.year.toString().padStart(4, "0") +
            "-" +
            etDate.month.toString().padStart(2, "0") +
            "-" +
            etDate.day.toString().padStart(2, "0")
        );
      }
    },
    cActivityOnChange(event, categoryType) {
      let courses = [];
      const cat2Courses = [];

      if (this.formValues.editMode && this.editChangeCount == 0) {
        if (categoryType == "CAT1") {
          courses = this.formValues.program.program_courses;
          this.isCategory1 = true;
        } else {
          const element = {
            courseName: this.formValues.program.courseTitleCat2,
          };
          cat2Courses.push(element);
          this.isCategory1 = false
        }
      } else {

        this.PROGRAMS.forEach((program) => {
          if (event == program.id) {
            if (program.category.categoryType == "CAT1") {
              courses = program.program_courses;
              this.isCategory1 = true;
            } else {
              const element = {
                courseName: program.courseTitleCat2,
              };
              cat2Courses.push(element);
              this.isCategory1 = false;
            }

            this.formValues.trainingCenterId = program.cpdProviderId;
          }
        });
      }
      this.COURSES = courses.length !== 0 ? courses : cat2Courses;

      this.editChangeCount += 1;
    },
    async submit() {
      this.formValues.color = this.color;
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("regsiterProgramEvent", this.formValues);
      this.$emit("close");
    },
  },
  watch: {
    "formValues.trainingDelivery": function (newValue) {
      this.formValues.trainingDelivery = newValue;
    },
    "formValues.start": function (newValue) {
      if (!this.formValues.editMode) {
        this.formValues.end = null;
        this.formValues.programId = null;
        this.PROGRAMS = [];
      }

      this.selectedStartDate = newValue;
      newValue || this.formValues.end
          ? (this.enableEndDate = false)
          : (this.enableEndDate = true);
    },
    "formValues.end": async function (newValue) {
      this.programLoading = true;
      this.selectedEndDate = newValue;
      const param = {
        startDate: this.selectedStartDate,
        endDate: this.selectedEndDate,
      };
      if (this.selectedEndDate) {
        const res = await ProgramService.getProgramByDate(
            param.startDate,
            param.endDate
        );
        if (res.status === 200) {
          this.loading = false;
          this.PROGRAMS = res.data;
        } else {
          this.loading = false;
          this.$toast.error(
              "There was a problem fetching CPD activity, Please try Again!"
          );
        }
      } else {
        this.PROGRAMS = [];
      }
      this.programLoading = false;
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}

.funder-row {
  margin-bottom: 12px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.event-outcome-field {
  box-sizing: border-box;
  height: 48px;
  min-height: 48px;
  resize: vertical;
}
</style>
